export default __webpack_public_path__ + "static/media/olnp-icon-48px.467bddb9.svg";